import { Button, Flex, Input, Spinner, Stack } from "@chakra-ui/react";
import COLOR from "../../../constant/COLOR";
import IMAGES from "../../../constant/IMAGES";
import formatLuna from "../../../utils/formatLuna";
import Container from "../../Container";
import Section1 from "./Section1";
import Section2 from "./Section2";
import {
  DateMonth,
  Text,
  Title,
  WrapperCalendar,
  WrapperDay,
  WrapperZodiac,
} from "./style";
import useResponsive from "../../../hooks/useResponsive";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface CalendarProps {
  detailCalendar: any;
  handleShare: any;
  isLoading: any;
  handleDateChange: any;
  selectedDate: any;
  handleGetCalendar: any;
}
const canchiImages = [
  IMAGES.z1,
  IMAGES.z2,
  IMAGES.z3,
  IMAGES.z4,
  IMAGES.z5,
  IMAGES.z6,
  IMAGES.z7,
  IMAGES.z8,
  IMAGES.z9,
  IMAGES.z10,
  IMAGES.z11,
  IMAGES.z12,
];
const nguHanhColorMap: { [key: string]: string } = {
  kim: COLOR.primary400,
  moc: COLOR.green700,
  thuy: COLOR.blue,
  hoa: COLOR.accent600,
  tho: COLOR.primary800,
};
const CalendarUpload: React.FC<CalendarProps> = ({
  detailCalendar,
  handleShare,
  isLoading,
  handleDateChange,
  selectedDate,
  handleGetCalendar,
}) => {
  const { isTabletOrLaptop, isMobile } = useResponsive();

  return (
    <Stack
      sx={{
        backgroundImage: `url(${IMAGES.bgBig})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container
        w="90vw"
        direction="column"
        gap="68px"
        mt="60px"
        position="relative"
      >
        <Flex alignItems="center" gap={1} justifyContent="flex-end">
          <DatePicker
            selected={selectedDate}
            onChange={handleDateChange}
            dateFormat="dd/MM/yyyy"
            customInput={
              <Input
                placeholder="Chọn ngày"
                variant="outline"
                bg="white"
                fontFamily="Quicksand"
                fontWeight={700}
                _focus={{ borderColor: COLOR.primary400 }}
                _hover={{ borderColor: COLOR.primary400 }}
              />
            }
          />
          <Button
            colorScheme="red"
            onClick={() => handleGetCalendar(selectedDate)}
          >
            Lấy dữ liệu lịch
          </Button>
        </Flex>
        <Flex justifyContent="space-between" width="100%">
          <img
            src={IMAGES.xheroLogo}
            alt=""
            style={{
              width: isMobile ? "100px" : "139px",
              height: "100%",
            }}
          />
          <img
            src={IMAGES.ptLogo}
            alt=""
            style={{
              width: isMobile ? "150px" : "199px",
              height: "auto",
            }}
          />
        </Flex>
        <Flex justifyContent="center">
          <img
            src={IMAGES.textC}
            alt=""
            style={{ width: isMobile ? "300px" : "508px" }}
          />
        </Flex>
        <WrapperCalendar>
          {detailCalendar ? (
            <Flex
              direction={isTabletOrLaptop ? "column" : "row"}
              mt="32px"
              justifyContent="space-between"
              width="100%"
              gap="33.45px"
            >
              <Section1 detailCalendar={detailCalendar} />
              <Section2 detailCalendar={detailCalendar} />
            </Flex>
          ) : (
            <Stack justifyContent="center" alignItems="center">
              <Spinner
                color="red.500"
                css={{ "--spinner-track-color": "colors.gray.200" }}
                borderWidth="4px"
                size="xl"
              />
            </Stack>
          )}
        </WrapperCalendar>
        <Flex
          width="100%"
          justifyContent="space-between"
          gap="56px"
          direction={isTabletOrLaptop ? "column" : "row"}
          mb="250px"
        >
          <WrapperZodiac>
            <Stack gap="32px" width="100%" mb="20px">
              <Title style={{ textAlign: "center" }}>Tuổi xung ngày</Title>
              <Stack
                sx={{
                  background: COLOR.primary300,
                  height: "1px",
                  width: "100%",
                }}
              />

              <Flex
                padding="0 32px"
                gap="16px"
                justifyContent="space-between"
                mb="50px"
              >
                {detailCalendar?.tuoiXungNgay.map((day: any, idx: any) => (
                  <Stack key={idx} width="100%">
                    <Stack
                      alignItems="center"
                      justifyContent="center"
                      width="100%"
                      gap="32px"
                    >
                      <img
                        src={canchiImages[day?.order - 1]}
                        alt=""
                        style={{ height: "auto", width: "80px" }}
                      />
                      <Title
                        style={{
                          textTransform: "capitalize",
                          color: COLOR.primary900,
                        }}
                      >{`${formatLuna[day?.key.toLowerCase()]}`}</Title>
                      <WrapperDay>
                        <Text
                          style={{
                            color: nguHanhColorMap[day?.nguHanh.toLowerCase()],
                            fontSize: "20px",
                            fontWeight: 600,
                          }}
                        >
                          {`${formatLuna[day?.nguHanh.toLowerCase()]}`}
                        </Text>
                      </WrapperDay>
                    </Stack>
                    <Stack
                      sx={{
                        background: COLOR.primary300,
                        height: "100%",
                        width: "1px",
                        display: idx === 1 ? "none" : "flex",
                      }}
                    />
                  </Stack>
                ))}
              </Flex>
            </Stack>
          </WrapperZodiac>
          <WrapperZodiac>
            <Stack gap="32px" width="100%" mb="20px">
              <Title style={{ textAlign: "center" }}>Tuổi xung tháng</Title>
              <Stack
                sx={{
                  background: COLOR.primary300,
                  height: "1px",
                  width: "100%",
                }}
              />

              <Flex
                padding="0 32px"
                gap="16px"
                justifyContent="space-between"
                width="100%"
                mb="50px"
              >
                {detailCalendar?.tuoiXungThang.map((day: any, idx: any) => (
                  <Stack key={idx} width="100%">
                    <Stack
                      alignItems="center"
                      justifyContent="center"
                      gap="32px"
                      width="100%"
                    >
                      <img
                        src={canchiImages[day?.order - 1]}
                        alt=""
                        style={{ height: "auto", width: "80px" }}
                      />
                      <Title
                        style={{
                          textTransform: "capitalize",
                          color: COLOR.primary900,
                        }}
                      >{`${formatLuna[day?.key.toLowerCase()]}`}</Title>
                      <WrapperDay>
                        <Text
                          style={{
                            color: nguHanhColorMap[day?.nguHanh.toLowerCase()],
                            fontSize: "20px",
                            fontWeight: 600,
                          }}
                        >
                          {`${formatLuna[day?.nguHanh.toLowerCase()]}`}
                        </Text>
                      </WrapperDay>
                    </Stack>
                    <Stack
                      sx={{
                        background: COLOR.primary300,
                        height: "100%",
                        width: "1px",
                        display: idx === 1 ? "none" : "flex",
                      }}
                    />
                  </Stack>
                ))}
              </Flex>
            </Stack>
          </WrapperZodiac>
        </Flex>
      </Container>
      <Flex
        sx={{
          position: "absolute",
          zIndex: 99,
          bottom: 0,
        }}
      >
        <img src={IMAGES.sanh} alt="" style={{ width: "100%" }} />
      </Flex>
      {isLoading ? (
        <Stack
          style={{
            position: "absolute",
            bottom: 0,
            left: "50%",
            zIndex: 999,

            transform: "translate(-50%,-50%)",
          }}
        >
          <Spinner
            color="red.500"
            css={{ "--spinner-track-color": "colors.gray.200" }}
            borderWidth="4px"
            size="xl"
          />
        </Stack>
      ) : (
        <img
          onClick={() => handleShare("download")}
          src={IMAGES.bttDowF}
          alt=""
          style={{
            width: "200px",
            position: "absolute",
            bottom: 0,
            left: "50%",
            transform: "translate(-50%,-50%)",
            cursor: "pointer",
            zIndex: 999,
            display: isTabletOrLaptop ? "none" : "flex",
          }}
        />
      )}
    </Stack>
  );
};

export default CalendarUpload;
